/* GYM PRO MASTER · motor de scroll (vanilla, sin dependencias) */
(function () {
  'use strict';
  var d = document, w = window, html = d.documentElement;
  var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) html.classList.add('gpx-static');

  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function ease(t) { return t * t * (3 - 2 * t); }
  /* interpola una tabla de keyframes [[p, v1, v2...], ...] */
  function track(keys, p) {
    if (p <= keys[0][0]) return keys[0].slice(1);
    for (var i = 1; i < keys.length; i++) {
      var b = keys[i];
      if (p <= b[0]) {
        var a = keys[i - 1], t = ease((p - a[0]) / (b[0] - a[0] || 1)), out = [];
        for (var j = 1; j < a.length; j++) out.push(a[j] + (b[j] - a[j]) * t);
        return out;
      }
    }
    return keys[keys.length - 1].slice(1);
  }

  /* ---------- keyframes: [progreso, ...valores] ---------- */
  // cámara: foco x, foco y (fracción del frame), escala, posición vertical del foco en pantalla
  var CAM = [[0, .5, .3, 1, .5], [.1, .5, .32, 1.04, .5], [.2, .5, .335, 1.5, .34], [.3, .5, .335, 1.5, .34],
    [.36, .5, .38, 1.36, .36], [.43, .5, .57, 1.42, .36], [.58, .5, .57, 1.42, .36], [.66, .5, .53, 1, .5],
    [.82, .5, .53, 1, .5], [.9, .5, .52, 1.03, .5], [1, .5, .52, 1.06, .5]];
  // piezas: desplazamiento vertical (fracción de la altura del frame), escala
  var DOM = [[0, 0, 1], [.12, 0, 1], [.2, -.045, 1.14], [.29, -.045, 1.14], [.34, 0, 1], [.63, 0, 1],
    [.72, -.075, 1.1], [.82, -.075, 1.1], [.875, .004, .995], [.91, 0, 1]];
  var FON = [[0, 0, 1], [.42, 0, 1], [.5, -.012, 1.12], [.58, -.012, 1.12], [.62, 0, 1], [.64, 0, 1],
    [.73, -.028, 1.1], [.82, -.028, 1.1], [.875, .003, .995], [.91, 0, 1]];
  var DIM = [[0, 0], [.12, 0], [.18, .62], [.3, .62], [.35, 0], [.42, 0], [.48, .62], [.57, .62], [.62, 0],
    [.64, 0], [.7, .45], [.82, .45], [.87, 0]];

  function Film(el) {
    this.el = el;
    this.frame = el.querySelector('[data-frame]');
    this.hero = el.querySelector('[data-hero]');
    this.dim = el.querySelector('[data-dim]');
    this.dom = el.querySelector('[data-piece="dom"]');
    this.fon = el.querySelector('[data-piece="fondos"]');
    this.sweep = el.querySelector('[data-sweep]');
    this.bar = el.querySelector('[data-progress]');
    this.texts = [].slice.call(el.querySelectorAll('[data-in]')).map(function (n) {
      return { n: n, a: parseFloat(n.getAttribute('data-in')), b: parseFloat(n.getAttribute('data-out')) };
    });
    this.p = 0; this.t = 0; this.raf = 0; this.layered = false;
    this.stage = el.querySelector('.gpx-stage');
    this.measure();
    var self = this, lastW = w.innerWidth;
    // en móvil la barra del navegador cambia la altura al hacer scroll: solo re-medimos si cambia el ancho o un salto grande
    w.addEventListener('resize', function () {
      if (w.innerWidth !== lastW || Math.abs(self.stage.clientHeight - self.vh) > 140) { lastW = w.innerWidth; self.measure(); self.kick(); }
    }, { passive: true });
    w.addEventListener('scroll', function () { self.kick(); }, { passive: true });
    this.lazy();
    this.kick();
  }
  Film.prototype.measure = function () {
    this.vw = this.stage.clientWidth || w.innerWidth; this.vh = this.stage.clientHeight || w.innerHeight;
    this.fw = this.frame.offsetWidth; this.fh = this.frame.offsetHeight;
  };
  Film.prototype.target = function () {
    var r = this.el.getBoundingClientRect();
    return clamp(-r.top / Math.max(1, r.height - this.vh), 0, 1);
  };
  Film.prototype.kick = function () {
    if (this.raf) return;
    var self = this;
    this.raf = requestAnimationFrame(function loop() {
      self.t = self.target();
      var dt = self.t - self.p;
      // suavizado corto (sin sensación de retraso); saltos grandes (anclas) se resuelven rápido
      self.p += dt * (Math.abs(dt) > .15 ? .5 : .22);
      if (Math.abs(self.t - self.p) < .0005) self.p = self.t;
      self.render(self.p);
      self.raf = self.p !== self.t ? requestAnimationFrame(loop) : 0;
    });
  };
  Film.prototype.lazy = function () {
    var self = this, imgs = [].slice.call(this.frame.querySelectorAll('[data-gpx-src]'));
    if (!imgs.length) return;
    var started = false;
    function go() {
      if (started) return; started = true;
      Promise.all(imgs.map(function (img) {
        img.src = img.getAttribute('data-gpx-src');
        return img.decode ? img.decode() : new Promise(function (ok, ko) { img.onload = ok; img.onerror = ko; });
      })).then(function () {
        self.layered = true; self.frame.classList.add('is-layered'); self.render(self.p);
      }).catch(function () { /* se queda en modo hero */ });
    }
    w.addEventListener('scroll', go, { once: true, passive: true });
    w.addEventListener('touchstart', go, { once: true, passive: true });
    if (d.readyState === 'complete') setTimeout(go, 600);
    else w.addEventListener('load', function () { setTimeout(go, 600); });
  };
  Film.prototype.render = function (p) {
    var c = track(CAM, p), s = c[2];
    var tx = -(c[0] - .5) * this.fw * s;
    var ty = (c[3] - .5) * this.vh - (c[1] - .5) * this.fh * s;
    var mx = Math.max(0, (this.fw * s - this.vw) / 2), my = Math.max(0, (this.fh * s - this.vh) / 2);
    tx = clamp(tx, -mx, mx); ty = clamp(ty, -my, my);
    this.frame.style.transform = 'translate(-50%,-50%) translate3d(' + tx.toFixed(1) + 'px,' + ty.toFixed(1) + 'px,0) scale(' + s.toFixed(4) + ')';
    if (this.bar) this.bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';

    if (this.layered) {
      var fh = this.fh, a = track(DOM, p), b = track(FON, p);
      this.dom.style.transform = 'translate3d(0,' + (a[0] * fh).toFixed(1) + 'px,0) scale(' + a[1].toFixed(4) + ')';
      this.fon.style.transform = 'translate3d(0,' + (b[0] * fh).toFixed(1) + 'px,0) scale(' + b[1].toFixed(4) + ')';
      this.dim.style.opacity = track(DIM, p)[0].toFixed(3);
      this.hero.style.opacity = (1 - clamp((p - .105) / .02, 0, 1)).toFixed(3);
      var fl = this.frame.classList;
      fl.toggle('m-fondos', p >= .4 && p < .63);
      fl.toggle('m-explode', p >= .63);
      fl.toggle('is-exploded', p >= .7 && p < .84);
      this.dom.classList.toggle('is-hot', p > .17 && p < .3);
      this.fon.classList.toggle('is-hot', p > .47 && p < .58);
    }
    if (this.sweep) {
      var k = clamp((p - .88) / .09, 0, 1);
      this.sweep.style.opacity = k > 0 && k < 1 ? Math.sin(k * Math.PI).toFixed(3) : 0;
      this.sweep.style.transform = 'translateX(' + (-100 + 200 * k).toFixed(1) + '%)';
    }
    for (var i = 0; i < this.texts.length; i++) {
      var o = this.texts[i], fw = .025, vin = o.a <= 0 ? 1 : clamp((p - o.a) / fw, 0, 1), vout = clamp((o.b - p) / fw, 0, 1), v = Math.min(vin, vout);
      o.n.style.opacity = v.toFixed(3);
      o.n.style.transform = 'translate3d(0,' + ((1 - v) * (p < o.a ? 18 : -18)).toFixed(1) + 'px,0)';
      o.n.style.visibility = v > 0 ? 'visible' : 'hidden';
    }
  };

  function init() {
    var film = d.querySelector('[data-gpx-film]');
    if (film && !reduce) new Film(film);

    /* aparición de secciones */
    var rev = d.querySelectorAll('.gpx-reveal');
    if ('IntersectionObserver' in w) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: .12 });
      [].forEach.call(rev, function (n) { io.observe(n); });
    } else [].forEach.call(rev, function (n) { n.classList.add('is-in'); });

    /* barra fija */
    var sticky = d.querySelector('[data-gpx-sticky]'), offer = d.getElementById('gpx-oferta'), offerIn = false;
    if (sticky) {
      if (offer && 'IntersectionObserver' in w) {
        new IntersectionObserver(function (es) { offerIn = es[0].isIntersecting; upd(); }, { threshold: .05 }).observe(offer);
      }
      var upd = function () {
        var past = film ? film.getBoundingClientRect().bottom < w.innerHeight * .6 : w.scrollY > w.innerHeight;
        var on = past && !offerIn;
        if (on !== sticky.classList.contains('is-on')) {
          sticky.classList.toggle('is-on', on);
          sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
          [].forEach.call(sticky.querySelectorAll('a,button'), function (b) { b.tabIndex = on ? 0 : -1; });
        }
      };
      w.addEventListener('scroll', upd, { passive: true }); upd();
    }

    /* variantes y cantidad */
    var sel = d.querySelector('[data-gpx-variant]');
    if (sel) sel.addEventListener('change', function () {
      var o = sel.options[sel.selectedIndex];
      [].forEach.call(d.querySelectorAll('[data-price]'), function (n) { n.textContent = o.getAttribute('data-price'); });
      var c = d.querySelector('[data-compare]');
      if (c) { var cv = o.getAttribute('data-compare'); c.textContent = cv || ''; c.hidden = !cv; }
    });
    var q = d.querySelector('[data-gpx-qty]');
    if (q) q.addEventListener('click', function (e) {
      var b = e.target.closest('[data-step]'); if (!b) return;
      var inp = q.querySelector('input'); inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(b.getAttribute('data-step'), 10));
    });
    var form = d.getElementById('gpx-buy-form');
    if (form) form.addEventListener('submit', function () {
      var btn = form.querySelector('[data-gpx-submit]'); if (btn) btn.classList.add('is-loading');
    });

    /* Botones de compra → formulario de Releasit.
       Releasit inserta su propio botón (#rsi_buy_now_button); nuestros botones lo activan
       (queda oculto con CSS). Si Releasit no carga en 3 s, respaldo: checkout de Shopify. */
    function rsiBtn() {
      return d.querySelector('#gpx-buy-form #rsi_buy_now_button') || d.querySelector('#rsi_buy_now_button, ._rsi-buy-now-button-app-block-hook button');
    }
    // se abre en el siguiente ciclo para que el clic original no cierre el popup recién abierto
    function openRSI(b) { setTimeout(function () { b.click(); }, 0); }
    function fallback(a) {
      if (!form) { location.hash = 'gpx-oferta'; return; }
      a.classList.add('is-loading');
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    }
    var waiting = false;
    w.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-gpx-buy]');
      if (!a) return;
      e.preventDefault(); e.stopPropagation();
      if (waiting) return;
      var b = rsiBtn();
      if (b) { openRSI(b); return; }
      waiting = true; a.classList.add('is-loading');
      var t0 = Date.now();
      (function poll() {
        var b2 = rsiBtn();
        if (b2) { waiting = false; a.classList.remove('is-loading'); openRSI(b2); return; }
        if (Date.now() - t0 > 3000) { waiting = false; a.classList.remove('is-loading'); fallback(a); return; }
        setTimeout(poll, 120);
      })();
    }, true);
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
